<div class="approval-status-container">
  <div *ngIf="loading" class="loading-indicator">
    <p>{{ 'approval.status.loading' | translate }}</p>
  </div>

  <div *ngIf="error" class="error-message">
    <p>{{ 'approval.status.error' | translate }}</p>
  </div>

  <div *ngIf="!loading && !error">
    <div *ngIf="approvalInstance; else noApproval">
      <div class="status-header">
        <h3>{{ 'approval.status.title' | translate }}: <span [ngClass]="statusClass">{{ statusText }}</span></h3>
      </div>

      <div class="approval-steps">
        <!-- 循環顯示步驟（支援單一階段顯示） -->
        <div *ngFor="let step of getDisplaySteps(); let i = index; trackBy: trackByStepIndex"
             class="step-item"
             [ngClass]="getStepClass(getStepDisplayStatus(i))">

          <!-- 步驟編號與名稱 -->
          <div class="step-number">{{ getActualStepIndex(i) + 1 }}</div>
          <div class="step-info">
            <div class="step-name">{{ step.name }}</div>

            <!-- 簽核人信息 -->
            <div class="approver-info">
              <!-- 如果是新資料結構，顯示部門角色資訊和可簽核人員列表 -->
              <div *ngIf="getStepApproverList(getActualStepIndex(i)).length > 0; else singleApprover">
                <div class="department-role-info">
                  <strong>{{ getStepDepartmentRoleInfo(getActualStepIndex(i)) }}</strong>
                </div>
                <div class="approver-list">
                  <span class="approver-list-label">{{ 'approval.status.available_approvers' | translate }}：</span>
                  <span *ngFor="let approver of getStepApproverList(getActualStepIndex(i)); let last = last; trackBy: trackByApproverId" class="approver-name">
                    {{ approver.name }}<span *ngIf="!last">、</span>
                  </span>
                </div>
              </div>

              <!-- 原本的單一簽核人顯示方式 -->
              <ng-template #singleApprover>
                {{ 'approval.status.approver' | translate }}：{{ step.approver.userName }}
                <span *ngIf="step.approver.roleName">({{ step.approver.roleName }})</span>
                <span *ngIf="step.approver.departmentName">[{{ step.approver.departmentName }}]</span>
              </ng-template>
            </div>

            <!-- 簽核狀態 -->
            <div class="step-status">
              <span [ngClass]="getStatusClass(getStepDisplayStatus(i))">{{ getStatusText(getStepDisplayStatus(i)) }}</span>
              <span *ngIf="getStepHistoryData(i)?.actionDate">
                ({{ getStepHistoryData(i).actionDate | date:'yyyy-MM-dd HH:mm' }})
              </span>
            </div>

            <!-- 顯示歷史資料：已有簽核意見 -->
            <div *ngIf="getStepHistoryData(i)?.comment" class="step-comment">
              {{ 'approval.status.comment' | translate }}：{{ getStepHistoryData(i).comment }}
            </div>

            <!-- 顯示歷史資料：已有簽名 -->
            <div *ngIf="getStepHistoryData(i)?.signature" class="step-signature">
              <p>{{ 'approval.status.signature' | translate }}：</p>
              <img [src]="getStepHistoryData(i).signature" [alt]="'approval.status.signature' | translate" class="signature-image" />
            </div>

            <!-- 顯示歷史資料：自訂表單資料 -->
            <div *ngIf="getStepHistoryData(i)?.customFormData && hasCustomFormData(getStepHistoryData(i).customFormData)" class="step-custom-form-data">
              <div class="custom-form-title">{{ 'approval.status.custom_form_data' | translate }}：</div>
              <div *ngFor="let field of getStepCustomFormFields(getActualStepIndex(i)); trackBy: trackByFieldName" class="custom-form-display">
                <div *ngIf="getStepHistoryData(i).customFormData[field.name]" class="form-field-display">
                  <!-- 使用 FormFieldRenderer 來顯示歷史資料 -->
                  <app-form-field-renderer
                    [field]="field"
                    [value]="getStepHistoryData(i).customFormData[field.name]"
                    [mode]="FieldRenderMode.DISPLAY">
                  </app-form-field-renderer>
                </div>
              </div>
            </div>

            <!-- 當前用戶是當前步驟的簽核人且階段未完成時，顯示簽核操作區域 -->
            <div *ngIf="!isStepReadOnly(i) && isCurrentApprover(getActualStepIndex(i)) && (!isStepActionCompleted(getActualStepIndex(i)))" class="approval-action-area">
              <!-- 調試輸出 -->
              {{ debugApprovalAreaConditions(i) }}

              <!-- 顯示目前簽核使用者資訊 -->
              <div class="current-user-info">
                <div class="current-user-label">
                  <i class="fas fa-user"></i>
                  {{ 'approval.status.current_user' | translate }}：
                  <strong>{{ getCurrentUserDisplayName() }}</strong>
                </div>
                <div class="user-action-notice">
                  {{ 'approval.status.user_action_notice' | translate }}
                </div>
              </div>

              <!-- 簽核意見輸入框 (根據配置決定是否顯示) -->
              <div *ngIf="showCommentField" class="form-group">
                <label for="comment{{getActualStepIndex(i)}}">{{ 'approval.status.comment_label' | translate }}：</label>
                <textarea
                  id="comment{{getActualStepIndex(i)}}"
                  [(ngModel)]="comment"
                  rows="4"
                  class="form-control"
                  [disabled]="actionInProgress"
                  [placeholder]="'approval.status.comment_placeholder' | translate"
                ></textarea>
              </div>

              <!-- 簽名區域 (根據配置決定是否顯示) -->
              <div *ngIf="showSignatureField" class="signature-container">
                <label>
                  {{ 'approval.status.signature' | translate }}：
                  <span *ngIf="signatureRequired" class="required-mark">*</span>
                </label>
                <app-form-signature
                  [id]="'signature_' + getActualStepIndex(i)"
                  [name]="'approval_signature'"
                  [label]="''"
                  [completeButtonText]="'approval.status.complete_signature' | translate"
                  [clearButtonText]="'approval.status.clear_signature' | translate"
                  [ngModel]="signature"
                  (ngModelChange)="onSignatureChange($event)"
                ></app-form-signature>

                <p *ngIf="signatureRequired" class="signature-hint">{{ 'approval.status.signature_hint' | translate }}</p>
              </div>

              <!-- 自訂表單區域 -->
              <div *ngIf="hasCustomForm(getActualStepIndex(i))" class="custom-form-container">
                <div *ngFor="let field of getStepCustomFormFields(getActualStepIndex(i)); trackBy: trackByFieldName" class="form-group custom-form-field">
                  <!-- 使用 FormFieldRenderer 統一處理所有字段類型 -->
                  <app-form-field-renderer
                    [field]="field"
                    [value]="getCustomFormFieldValue(getActualStepIndex(i), field.name)"
                    [mode]="FieldRenderMode.FORM"
                    (valueChange)="updateCustomFormFieldValue(getActualStepIndex(i), field.name, $event)">
                  </app-form-field-renderer>
                </div>
              </div>

              <!-- 簽核操作按鈕 -->
              <div class="action-buttons">
                <button
                  type="button"
                  class="btn btn-success"
                  (click)="approve(getActualStepIndex(i))"
                  [disabled]="actionInProgress || (signatureRequired && (!signature || !signature.imageData)) || !isCustomFormValid(getActualStepIndex(i))"
                >
                  {{ 'approval.status.approve' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  (click)="reject(getActualStepIndex(i))"
                  [disabled]="actionInProgress || (signatureRequired && (!signature || !signature.imageData)) || !isCustomFormValid(getActualStepIndex(i))"
                >
                  {{ 'approval.status.reject' | translate }}
                </button>
              </div>

              <!-- 新增：退回選項區域 (條件顯示) -->
              <div *ngIf="showRejectOptions && currentRejectStepIndex === getActualStepIndex(i)" class="reject-options-container mt-3">
                <div class="card">
                  <div class="card-header">
                    <h6 class="mb-0">{{ 'approval.reject.select_type' | translate }}</h6>
                  </div>
                  <div class="card-body">
                    <!-- 退回類型選擇 -->
                    <div class="mb-3">
                      <!-- 🆕 完全拒絕選項（根據配置顯示/隱藏） -->
                      <div *ngIf="approvalWorkflowConfig?.rejectOptions?.enableCompleteReject !== false"
                           class="form-check mb-2"
                           [class.selected]="rejectFormData.rejectType === 'complete_reject'"
                           (click)="selectRejectType('complete_reject')">
                        <div class="form-check-label">
                          <strong>
                            <i class="fas fa-times-circle text-danger me-2"></i>
                            {{ 'approval.reject.complete_reject' | translate }}
                          </strong>
                          <br>
                          <small class="text-muted">{{ 'approval.reject.complete_reject_desc' | translate }}</small>
                        </div>
                      </div>

                      <!-- 退回給提交人選項 -->
                      <div class="form-check mb-2" 
                           [class.selected]="rejectFormData.rejectType === 'return_to_submitter'"
                           (click)="selectRejectType('return_to_submitter')">
                        <div class="form-check-label">
                          <strong>
                            <i class="fas fa-user-edit text-primary me-2"></i>
                            {{ 'approval.reject.return_to_submitter' | translate }}
                          </strong>
                          <br>
                          <small class="text-muted">{{ 'approval.reject.return_to_submitter_desc' | translate }}</small>
                        </div>
                      </div>
                      
                      <!-- 退回到指定階段選項 -->
                      <div class="form-check mb-2" 
                           *ngIf="availableReturnSteps.length > 0" 
                           [class.selected]="rejectFormData.rejectType === 'return_to_step'"
                           (click)="selectRejectType('return_to_step')">
                        <div class="form-check-label">
                          <strong>
                            <i class="fas fa-undo text-warning me-2"></i>
                            {{ 'approval.reject.return_to_step' | translate }}
                          </strong>
                          <br>
                          <small class="text-muted">{{ 'approval.reject.return_to_step_desc' | translate }}</small>
                        </div>
                      </div>
                    </div>
                    
                    <!-- 退回階段選擇 -->
                    <div class="mb-3" *ngIf="rejectFormData.rejectType === 'return_to_step' && availableReturnSteps.length > 0">
                      <label class="form-label fw-bold">
                        {{ 'approval.reject.select_step' | translate }}
                        <span class="text-danger">*</span>
                      </label>
                      <select class="form-select" [(ngModel)]="rejectFormData.returnToStepId" required>
                        <option value="">{{ 'approval.reject.select_step_placeholder' | translate }}</option>
                        <option *ngFor="let step of availableReturnSteps; trackBy: trackByStepId" [value]="step.stepId">
                          {{ step.displayText }}
                        </option>
                      </select>
                      <div class="form-text">
                        {{ 'approval.reject.select_step_help' | translate }}
                      </div>
                    </div>
                    
                    <!-- 拒絕原因 -->
                    <div class="mb-3">
                      <label class="form-label fw-bold">
                        {{ 'approval.reject.reason' | translate }} 
                        <span class="text-danger">*</span>
                      </label>
                      <textarea class="form-control" rows="3" 
                                [(ngModel)]="rejectFormData.rejectReason"
                                [placeholder]="'approval.reject.reason_placeholder' | translate"
                                required
                                maxlength="500">
                      </textarea>
                      <div class="form-text">
                        {{ 'approval.reject.reason_help' | translate }}
                      </div>
                    </div>
                    
                    <!-- 警告提示 -->
                    <div class="alert alert-warning" role="alert">
                      <i class="fas fa-exclamation-triangle me-2"></i>
                      {{ 'approval.reject.warning' | translate }}
                    </div>
                    
                    <!-- 操作按鈕 -->
                    <div class="d-flex gap-2">
                      <button type="button" class="btn btn-secondary" (click)="cancelReject()">
                        {{ 'common.cancel' | translate }}
                      </button>
                      <button type="button" class="btn btn-danger" 
                              (click)="confirmReject(getActualStepIndex(i))"
                              [disabled]="!rejectFormData.rejectReason.trim() || 
                                         (rejectFormData.rejectType === 'return_to_step' && !rejectFormData.returnToStepId)">
                        <i class="fas fa-times me-2"></i>
                        {{ 'approval.reject.confirm' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 操作中提示 -->
              <div *ngIf="actionInProgress" class="processing-indicator">
                {{ 'approval.status.processing' | translate }}
              </div>
            </div>

            <!-- 操作結果提示，只顯示在當前步驟中
                 修正：使用安全的方式檢查 actionResult 屬性 -->
            <ng-container *ngIf="getStepActionResult(getActualStepIndex(i)) as actionResult">
              <div *ngIf="actionResult" class="step-action-result"
                  [ngClass]="{'success': actionResult.success, 'error': !actionResult.success}">
                {{ actionResult.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- 沒有簽核實例時顯示 -->
    <ng-template #noApproval>
      <p>{{ 'approval.status.no_approval' | translate }}</p>
    </ng-template>
  </div>
</div>

